import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { SurveyForm } from "./SurveyForm";

/**
 * One pop-up survey for students. Closing by any route (X, outside click,
 * the skip link) calls onSkip; a completed form shows the thank-you line.
 */
export const StudentSurveyDialog = ({ survey, open, onSkip, onSubmit, eyebrow, skipLabel, submitLabel, testid }) => {
  const [thanks, setThanks] = useState("");
  const [closing, setClosing] = useState(false);

  const skip = async () => {
    if (thanks || closing) return;
    setClosing(true);
    try { await onSkip(); } finally { setClosing(false); }
  };

  const submit = async (answers) => {
    const t = await onSubmit(answers);
    setThanks(t || "Thank you.");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) (thanks ? onSkip(true) : skip()); }}>
      <DialogContent data-testid={testid} className="max-h-[90vh] overflow-y-auto border-border bg-bone p-0 sm:max-w-xl">
        <div className="border-b border-border bg-sand px-6 pt-7 pb-5 lg:px-8">
          <p className="text-[13px] font-semibold uppercase tracking-[0.22em] text-tangerine">{eyebrow}</p>
          <DialogTitle className="mt-2 font-serif text-3xl font-normal leading-tight text-ink">{survey.title}</DialogTitle>
          <DialogDescription className="mt-2 text-base leading-relaxed text-olive">{survey.intro}</DialogDescription>
        </div>
        <div className="px-6 py-6 lg:px-8">
          {thanks ? (
            <div data-testid={`${testid}-thanks`}>
              <p className="font-serif text-2xl text-ink">Thank you.</p>
              <p className="mt-2 text-base text-olive">{thanks}</p>
              <button type="button" onClick={() => onSkip(true)} data-testid={`${testid}-close`} className="mt-6 rounded-full bg-ink px-6 py-3 text-base font-semibold text-sand hover:bg-forest">Close</button>
            </div>
          ) : (
            <>
              <SurveyForm survey={survey} onSubmit={submit} submitLabel={submitLabel} />
              <button type="button" onClick={skip} disabled={closing} data-testid={`${testid}-skip`} className="mt-4 text-sm font-semibold text-olive underline-offset-4 hover:text-ink hover:underline disabled:opacity-50">
                {skipLabel}
              </button>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
